<template>
    <div class="container-fluid">
        <div class="diagram pt-3 pb-3 d-flex flex-row text-center">
            <div class="col-3 diagram__levels p-0 d-flex flex-column justify-content-around">
                <div class="diagram__block">
                    <h6 class="diagram__level-title">
                        <strong>Macro Level</strong>
                        <br>
                        <small class="mb-0"><em>Country, region</em></small>
                    </h6>
                </div>
                <div class="diagram__block pt-5">
                    <h6 class="diagram__level-title">
                        <strong>Meso Level</strong>
                        <br>
                        <small class="mb-0"><em>School</em></small>
                    </h6>
                </div>
                <div class="diagram__block pt-5">
                    <h6 class="diagram__level-title">
                        <strong>Micro Level</strong>
                        <br>
                        <small class="mb-0"><em>Student, Teacher</em></small>
                    </h6>
                </div>
                <div class="diagram__caption diagram__caption--vert">
                    <i class="l-arrow l-arrow--up"></i>
                    <span>Consistency</span>
                    <i class="l-arrow l-arrow--down"></i>
                </div>
                <LevelShapes class="diagram__level-shapes"/>
            </div>
            <div class="d-flex w-100 diagram__columns scrollbar">
                <div class="diagram__caption diagram__caption--fixed">
                    <i class="l-arrow l-arrow--left"></i>
                    <span>Consistency</span>
                    <i class="l-arrow l-arrow--right"></i>
                </div>
                <div class="diagram__caption diagram__caption--fixed last">
                    <i class="l-arrow l-arrow--left"></i>
                    <span>Consistency</span>
                    <i class="l-arrow l-arrow--right"></i>
                </div>
                <DiagramColumn category="Inputs"
                               :macro="macroInputs"
                               :meso="mesoInputs"
                               :micro="microInputs"/>
                <DiagramColumn category="Processes"
                               :macro="macroProcesses"
                               :meso="mesoProcesses"
                               :micro="microProcesses"/>
                <DiagramColumn category="Outcomes"
                               :macro="macroOutcomes"
                               :meso="mesoOutcomes"
                               :micro="microOutcomes"/>
            </div>
        </div>
        <DetailsModal/>
    </div>
</template>

<script>
import
{ mapGetters } from 'vuex';
import DetailsModal from './DetailsModal';
import DiagramColumn from './DiagramColumn';
import LevelShapes from './LevelShapes';

export default {
  components: {
    LevelShapes,
    DetailsModal,
    DiagramColumn,
  },
  computed: {
    ...mapGetters({
      macroInputs: 'diagram/macroInputs',
      macroProcesses: 'diagram/macroProcesses',
      macroOutcomes: 'diagram/macroOutcomes',
      mesoInputs: 'diagram/mesoInputs',
      mesoProcesses: 'diagram/mesoProcesses',
      mesoOutcomes: 'diagram/mesoOutcomes',
      microInputs: 'diagram/microInputs',
      microProcesses: 'diagram/microProcesses',
      microOutcomes: 'diagram/microOutcomes',
    }),
  },
  methods: {
    openDetailsModal(item) {
      this.$store.commit('diagram/item', item);
      this.$store.commit('diagram/isDetailsModalOpen', true);
    },
  },
};
</script>
